import React from "react";
import './UI.css';

const History = () => {
    return (
        <div className='history'>
            <h4 >History </h4>
            <hr />
        </div>
    );
};

export default History;